import { Observable } from 'rxjs';
import { axiosInstance } from './axios.config.api';
import { map } from 'rxjs/operators';
import { TermsOfUseModel } from '@/models/terms-of-use.model';

export default class TermsOfUseApi {
    getTermsOfUse(): Observable<TermsOfUseModel> {
        return axiosInstance().get<TermsOfUseModel>('settings/terms-of-use')
            .pipe(map((response) => response.data));
    }
}
